import { render, staticRenderFns } from "./TableNewStore.vue?vue&type=template&id=099a9a1c&scoped=true&"
import script from "./TableNewStore.vue?vue&type=script&lang=js&"
export * from "./TableNewStore.vue?vue&type=script&lang=js&"
import style0 from "./TableNewStore.vue?vue&type=style&index=0&id=099a9a1c&scoped=true&lang=scss&ref=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099a9a1c",
  null
  
)

export default component.exports